import { isNil } from '@wistia/type-guards';
import { defaultLocales, defaultTimeZone } from './constants';

/**
 * Get local year, month, day parts from a Date using Intl.DateTimeFormat.
 * This ignores the time of day (hours, minutes, etc.).
 *
 * @param {Date} date
 * @returns {{ year: number, month: number, day: number }}
 */
export const getLocalDateParts = (date: Date): { year: number; month: number; day: number } => {
  const parts = new Intl.DateTimeFormat(defaultLocales, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: defaultTimeZone,
  }).formatToParts(date);

  const yearPart = parts.find((part) => part.type === 'year');
  const monthPart = parts.find((part) => part.type === 'month');
  const dayPart = parts.find((part) => part.type === 'day');

  if (isNil(yearPart) || isNil(monthPart) || isNil(dayPart)) {
    throw new Error('Failed to parse date parts');
  }

  const year = parseInt(yearPart.value, 10);
  const month = parseInt(monthPart.value, 10);
  const day = parseInt(dayPart.value, 10);

  return { year, month, day };
};
